import { Media } from './media';
import { Config } from '../../config/config';

export class Img extends Media { 

    tmb: string;
    height: string;
    width: string;

    constructor(){

        super();
        this.tmb = "";
    }

    /* get tmbRewrite(): string {

        if(this.tmb !== "")
        return this.tmb.substring(1);
        else
        return this.tmb;
    } */

    get urltmb(): string {

        if(  this.tmb !== null && this.tmb !== undefined )
        return  Config.urlserveur + this.tmb;
        else
        return null;
    }

    



}